import ContactFormPro from "@/components/feature/ContactFormPro";

interface ContactFormProps {
  endpoint?: string;
  formId?: string;
}

export default function ContactForm({ endpoint: _endpoint, formId }: ContactFormProps) {
  return <ContactFormPro variant="split" formId={formId || "devis-form"} />;
}